import React, { useState, useEffect } from "react";
import "./TopBar.scss";
import { useSelector, useDispatch } from "react-redux";
// import { loginReducer } from "../../Redux/store";
import { AccessTockenReducer } from "../../Redux/store";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import { sidebarReducer } from "../../Redux/store";
// import { FaBars } from "react-icons/fa";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
import { Button, Menu, MenuItem } from "@mui/material";

// import { Typography } from "@mui/material";
// import { useMsal } from "@azure/msal-react";
import { ReactComponent as LogoSVG } from "../../images/CMS_UMS_LOGO.svg";

import { ReactComponent as ProfileSVG } from "../../images/gg_profile.svg";
import { ReactComponent as DropDownSVG } from "../../images/new_ui/dropdown.svg";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import TickImage from "../../images/new_ui/mark.png";



const TopBar = () => {

  const token = useSelector((state) => state.AccessTocken.accessTocken);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
 const [resetPassword, setResetPassword] = useState(false);
  const [isLeftSelected, setIsLeftSelected] = useState(() => {
    const savedState = localStorage.getItem('isUMSSelected');
    if (savedState !== null) {
      return savedState === 'true';
    }
    // Default to CMS (false) if no saved state
    return false;
  });

  useEffect(() => {
    const currentPath = location.pathname;
    
    if (["/home-cms", "/content-list", "/past-session"].includes(currentPath)) {
      setIsLeftSelected(false);
      localStorage.setItem('isUMSSelected', 'false');
    } else if (["/newhome-ums", "/list-users", "/list-roles"].includes(currentPath)) {
      setIsLeftSelected(true);
      localStorage.setItem('isUMSSelected', 'true');
    }

    getCompanyDetails();
   if(sessionStorage.getItem("userRoleID")==="98"){
    setResetPassword(false);
   }
   else{
    setResetPassword(true);
   }
    // Only set the toggle for cms_admin users
    if (sessionStorage.getItem("userRoleType") === "cms_admin") {
      
    } else {
      setIsLeftSelected(false);
  
      localStorage.setItem('isUMSSelected', 'false');
    }
  }, [location.pathname]);

  const handleToggle = () => {
    const newState = !isLeftSelected;
    setIsLeftSelected(newState);
    localStorage.setItem('isUMSSelected', newState.toString());
    if (newState) {
      navigate("/newhome-ums");
    } else {
      navigate("/home-cms");
    }
  };

  const toggleButtonClass = isLeftSelected ? "left-selected" : "right-selected";
  const toggleUMS = isLeftSelected ? "left-selected-UMS" : "right-selected-UMS";
  const toggleCMS = isLeftSelected ? "left-selected-CMS" : "right-selected-CMS";
  const toggleOtpButton = isLeftSelected ? "left-otp" : "right-otp";
  // useEffect(() => {
  //   let userData = JSON.parse(sessionStorage.getItem("userdata"));
  //   let tokenExpiresAtUTC = new Date(userData.tokenExpiresAt);
  //   let offsetInMinutes = new Date().getTimezoneOffset();
  //   let offsetMilliseconds = offsetInMinutes * 60 * 1000;
  
  //   // Adjust expiration time with the offset
  //   let targetTime = new Date(tokenExpiresAtUTC.getTime() - offsetMilliseconds);
  
  //   let warningTime = 30 * 1000; // 30 seconds in milliseconds
  //   let warningShown = false;
  //   let logoutTriggered = false;
  
  //   const checkSessionStatus = () => {
  //     let currentTime = new Date();
  //     let timeRemaining = targetTime.getTime() - currentTime.getTime();
  
  //     // Show warning exactly 30 seconds before expiration
  //     if (timeRemaining <= warningTime && timeRemaining > warningTime - 1000 && !warningShown) {
  //       toast.warn("Session is about to expire in 30 seconds", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  //       warningShown = true;
  //     }
  
  //     // Trigger logout when session expires
  //     if (timeRemaining <= 0 && !logoutTriggered) {
  //       logoutTriggered = true;
  //       toast.error("Session expired. Logging out...", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  
  //       setTimeout(() => {
  //         dispatch(AccessTockenReducer.accessTocken(""));
  //         dispatch(AccessTockenReducer.refreshTocken(""));
  //         sessionStorage.clear();
  //         navigate("/login");
  //       }, 3000);
  //     }
  //   };
  
  //   const intervalId = setInterval(checkSessionStatus, 1000);
  
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [JSON.parse(sessionStorage.getItem("userdata")).tokenExpiresAt]);

  useEffect(() => {
    let userData = JSON.parse(sessionStorage.getItem("userdata"));
    let tokenExpiresAtUTC = new Date(userData.tokenExpiresAt);
    let offsetInMinutes = new Date().getTimezoneOffset();
    let offsetMilliseconds = offsetInMinutes * 60 * 1000; 
    let targetTime = new Date(tokenExpiresAtUTC.getTime() - offsetMilliseconds);
    let warningTime = 30 * 1000;
    let toastShown = false;
    const intervalId = setInterval(() => {
    let currentTime = new Date();
    let timeRemaining = targetTime.getTime() - currentTime.getTime();

      if (timeRemaining <= warningTime) {
       
        if (toastShown === false) {
          toast.warn("Session is about to expire in 30 seconds", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        toastShown = true;
      }

      if (timeRemaining <= 0) {
        toast.error("Token Expired. Logging out...", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        toastShown = true;
 
        setTimeout(() => {
         clearInterval(intervalId);
         dispatch(AccessTockenReducer.accessTocken(""));
          dispatch(AccessTockenReducer.refreshTocken(""));
          sessionStorage.clear();
       
          navigate("/login");
        }, 3000);
     
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [JSON.parse(sessionStorage.getItem("userdata")).tokenExpiresAt]);

  const [companyName, setCompanyName] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const handleVerifyClick = () => {
    setIsVerified(true);  
  };


  let options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  // const ShowRecord = () => {
  //   sessionStorage.setItem("navigate", "Settings");
  //   dispatch(sidebarReducer.stringUpdate("Settings"));
  // };

  const getCompanyDetails = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios

      .get(
        "companyprofile/listbyid/" +
          JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
        {
          headers: {
            Authorization:
              "Bearer" + " " + sessionStorage.getItem("access_token"),
          },
        }
      )
      // .get("userProfile/getAllUsers")

      .then((response) => {
       
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
      
          setCompanyName(response.data.data.te_companyname);
          sessionStorage.setItem(
            "companyname",
            response.data.data.te_companyname
          );
          // setUserData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  // const [isLeftSelected, setIsLeftSelected] = useState(false);

  // const handleToggle = () => {
  //   setIsLeftSelected(!isLeftSelected);
  //   if (!isLeftSelected) {
  //     navigate("/newhome-ums");
  //   } else {
  //     navigate("/home-cms");
  //   }
  // };


  const logoutHandler = async (e) => {
    if (token) {
      try {
        const response = await axios.post("auth/logout", null, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionStorage.getItem("access_token"),
          },
        });

        if (response.status === 200) {
          // Successful logout
          dispatch(AccessTockenReducer.accessTocken(""));
          dispatch(AccessTockenReducer.refreshTocken(""));
          sessionStorage.clear();
          // e.preventDefault();
          navigate("/login");
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Unauthorized
          dispatch(AccessTockenReducer.accessTocken(""));
          dispatch(AccessTockenReducer.refreshTocken(""));
          sessionStorage.clear();
          // e.preventDefault();
          navigate("/login");
        }
        // Handle other error cases if needed
      }
    } else {
      dispatch(AccessTockenReducer.accessTocken(""));
      dispatch(AccessTockenReducer.refreshTocken(""));
      sessionStorage.clear();
      // e.preventDefault();
      navigate("/login");
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    navigate("/resetPassword");
  };


 




  return (
    <header className="header-bar">
      <ToastContainer></ToastContainer>
      <div style={{ padding: "0px 20px", height: "100%" }}>
        {/* <AppBar> */}
        {/* <Toolbar className="header-section-div"> */}
        {/* <div
              className={`btn-toggle menuButton`}
              onClick={() => dispatch(AccessTockenReducer.sidebar_toggle(true))}
              
            >
              <FaBars />
            </div> */}
        <div className="header-bar">
          <div className="top-bar">
            <div className="left-items">
              {/* <p>Current State: {state}</p>
      <p>Action Events: {count}</p>
      <p>{remaining} seconds remaining</p> */}
              {sessionStorage.getItem("companyname") || companyName ? (
                <p className="company_name">
                  {" "}
                  {sessionStorage.getItem("companyname")
                    ? sessionStorage.getItem("companyname")
                    : companyName}
                </p>
              ) : (
                <div>
                  <LogoSVG style={{ width: "60px", height: "auto" }} />
                </div>
              )}
               {sessionStorage.getItem("userRoleID")!=="98" &&

              <div className={`otp_code ${toggleOtpButton}`}>
                Device code - {sessionStorage.getItem("vrdevicecode")}
              </div>
}
            {/* <button className="verify-button" onClick={handleVerifyClick}>Verify</button> */}
        {/* {isVerified && (
          <img
            src={TickImage}
            alt="Verified"
            style={{ width: "30px", height: "30px"}}
          />
        )} */}

            </div>
            <div className="right-items">
              <div>
                {isLeftSelected && (
                  <nav className="nav-items ums">
                    <NavLink exact to="/newhome-ums" activeClassName="active">
                      Home
                    </NavLink>

                    <NavLink
                      to="/list-users"
                      isActive={(match, location) =>
                        location.pathname === "/list-users" ||
                        location.pathname === "/add" ||
                        location.pathname === "/edit"
                      }
                      activeClassName="active"
                    >
                      Users
                    </NavLink>

                    <NavLink to="/list-roles" activeClassName="active">
                      Roles & Permissions
                    </NavLink>
                    <NavLink to="/list-devices" activeClassName="active">
                      Devices
                    </NavLink>
                  </nav>
                )}
                {!isLeftSelected && (
                  <nav className="nav-items cms">
                    <NavLink exact to="/home-cms" activeClassName="active" style={{color:"white"}}>
                      Home
                    </NavLink>
                    {/* {(location.pathname === "/content-list" || location.pathname === "/Content-recyle") && (
  <NavLink exact to="/Content-recyle" activeClassName="active" style={{color:"white"}}>
    Recycle Bin
  </NavLink>
)} */}
                  </nav>
                )}
              </div>
              <div className="cms-ums-toggle" onClick={handleToggle}>
              {sessionStorage.getItem("userRoleType")==="cms_admin"&&<p className={` ${toggleUMS}`}>UMS</p>}
                {sessionStorage.getItem("userRoleType")==="cms_admin"&&<div className="custom-slider-button">
                  <div className="slider-track">
                    <button
                      className={`round-button ${toggleButtonClass}`}
                      onClick={handleToggle}
                    />
                  </div>
                </div>}
               <p className={` ${toggleCMS}`}>CMS</p>
              </div>
              <div>
                <ProfileSVG style={{ width: "30px", height: "auto" }} />
              </div>
              <div style={{ color: "#FFFFFF", fontSize: "12px" }}>
                {JSON.parse(sessionStorage.getItem("userdata")).te_username}
                <Button
                  aria-controls="dropdown-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  variant="contained"
                >
                  <DropDownSVG
                    style={{ width: "20px", height: "auto", fill: "#FFFFFF" }}
                  />
                </Button>
                <Menu
                  id="dropdown-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                  {resetPassword && <MenuItem onClick={handleReset}>Reset Password</MenuItem>}

                  {/* <MenuItem onClick={handleReset}>Reset Password</MenuItem> */}
                  <MenuItem onClick={logoutHandler}>Logout</MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </div>

        {/* <SearchBarComponent className="search-bar-div"/>
            <Typography variant="h6" className="title">
              <img
                style={{ width: "182px" }}
                src={require("../../images/tataelxsilogo2.png")}
                alt="TATA Elxsi"
              />
            </Typography> */}
      </div>
    </header>
  );
};

export default TopBar;
